import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { fetchAuthOrganizations } from 'src/redux/authOrganizations/authOrganization.action';
import { getAuthOrganizations } from 'src/redux/authOrganizations/authOrganization.selector';
import { fetchAuthUsers } from 'src/redux/authUsers/authUser.action';
import { getCurrentAuthUser, getAuthUsers } from 'src/redux/authUsers/authUser.selector';

const getRouteToRender = (orgState, userState) => {
	const allRouteChoices = {
		needs_bb_id: {
			initial: '/setup/terms',
			needs_auth: '/setup/connect_crm',
			needs_sync: '/setup/processing',
			syncing: '/setup/syncing',
			sync_error: '/setup/sync_error',
			complete: '/setup/user',
			intermission: '/setup/intermission',
		},
		complete: {
			complete: window.localStorage.redirectedFrom || '/dashboard/overview',
		},
	};
	const choicesGivenUserState = allRouteChoices[userState];
	const choiceGivenOrgState = choicesGivenUserState ? choicesGivenUserState[orgState] : undefined;

	// if the states were invalid, just send user to the dashboard
	return choiceGivenOrgState || '/dashboard/overview';
};

class Landing extends Component {
	componentDidMount() {
		this.props.fetchAuthUsers();
		this.props.fetchAuthOrganizations();
	}

	componentWillUnmount() {
		const route = getRouteToRender(
			this.props.authOrganizations[0].setup_state,
			this.props.currentAuthUser.setup_state,
		);
		if (route === window.localStorage.redirectedFrom) {
			delete window.localStorage.redirectedFrom;
		}
	}

	render() {
		// wait for authOrganizations result
		if (!this.props.authUsers.length || !this.props.authOrganizations.length) {
			return null;
		}

		return (
			<Redirect
				to={getRouteToRender(
					this.props.authOrganizations[0].setup_state,
					this.props.currentAuthUser.setup_state,
				)}
			/>
		);
	}
}

const mapStateToProps = state => ({
	authOrganizations: getAuthOrganizations(state),
	currentAuthUser: getCurrentAuthUser(state),
	authUsers: getAuthUsers(state),
});

const actions = {
	fetchAuthOrganizations,
	fetchAuthUsers,
};

Landing = connect(mapStateToProps, actions)(Landing);

export default Landing;



// WEBPACK FOOTER //
// ./src/ConnectedComponents/Landing/index.js